import { render, staticRenderFns } from "./rate-item.mpx?vue&type=template&id=38fb9f98&isComponent&outputPath=components%2Frate-itemf29d1196%2Findex"
import script from "./rate-item.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Frate-itemf29d1196%2Findex"
export * from "./rate-item.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Frate-itemf29d1196%2Findex"
import style0 from "./rate-item.mpx?vue&type=style&index=0&id=38fb9f98&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_f29d1196%22%7D&isComponent&outputPath=components%2Frate-itemf29d1196%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports